/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\Company\CompanyRow\CompanyRow.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Thursday January 18th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Thursday January 18th 2024 11:54:59 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { TableCell, TableRow } from "@mui/material"
import RouterPathResolver from "Config/Router/RouterPathResolver"
import Actions from "Content/Actions/Actions"
import ModalCompany from "Content/Modals/ModalCompany/ModalCompany"
import translator from "MultiLanguage/TranslationWrapper"
import CompanyService from "Services/CompanyService/CompanyService"
import { CompanyDataType, CompanyDataUpdate } from "Type/company.type"
import { formatSiren } from "Utils/company.utils"
import { useState, MouseEvent, useEffect, useRef } from "react"
import { useNavigate } from "react-router-dom"

function CompanyRow(props: CompanyDataType) {
    const navigate = useNavigate();
    const [showModalCompany, setShowModalCompany] = useState(false);
    const firstLoad = useRef(true);
    const [company, setCompany] = useState<CompanyDataUpdate>({
        Name: props.Name,
        Siren: formatSiren(props.Siren),
        StandardPhoneNumber: props.StandardPhoneNumber,
        Address: props.Address,
        PostalCode: props.PostalCode,
        City: props.City,
        State: props.State,
        Country: props.Country,
    });
    const [updatableFileds, setUpdatableFileds] = useState({
        Name: undefined,
        Siren: undefined,
        StandardPhoneNumber: undefined,
        Address: undefined,
        PostalCode: undefined,
        City: undefined,
        State: undefined,
        Country: undefined,
    });

    useEffect(() => {
        if (!firstLoad.current)
            setCompany(updatableFileds);
        else
            firstLoad.current = false;
    }, [updatableFileds]);

    const openModalCompany = (e: any) => {
        e.stopPropagation();
        setShowModalCompany(true);
    };
    const handleToggleCompanyModal = (e: MouseEvent<HTMLElement>) => {
        setShowModalCompany(false);
    };

    return(
        <TableRow>
            <TableCell sx={{cursor:"pointer"}} onClick={() => navigate(RouterPathResolver.pathCompany_BY_ID.path.replace(":id", props.id))}>
                {company.Name}
            </TableCell>
            <TableCell>
                {company.Siren}
            </TableCell>
            <TableCell>
                {company.StandardPhoneNumber}
            </TableCell>
            <TableCell>
                {company.Address}
            </TableCell>
            <TableCell>
                {company.City}
            </TableCell>
            <TableCell>
                {company.PostalCode}
            </TableCell>
            <TableCell>
                {company.State}
            </TableCell>
            <TableCell>
                {company.Country}
            </TableCell>
            <TableCell>
                <Actions variant={"minimal"} disabled={false} manageUpdate={openModalCompany} />
            </TableCell>
            <ModalCompany updateCompany={setUpdatableFileds} CompanyID={props.id} data={props} submitFunc={CompanyService.updateCompany} title={translator.decode("dynamic.company")} show={showModalCompany} onClose={handleToggleCompanyModal} closeModal={handleToggleCompanyModal} />
        </TableRow>
    )
};

export default CompanyRow;
